<template>
  <div class="container">
    <div class="top-bg">
      <!--<div class="return" @click="linkytowin">
        <span>返回优途</span>
      </div>-->
      <img src="../../static/images/qie01.jpg" alt />
    </div>
    <div class="ct">
      <ul class="breadnav ct-centre">
        <li @click="linkytowin"> <img src="../../static/images/icon_logo.png" alt=""></li>
        <li class="icon">&gt;</li>
        <li @click=" linkindex">专题首页</li>
        <li class="icon">&gt;</li>
        <li>老师简介</li>
      </ul>
      <!--<shaixuan class="saixuan"></shaixuan>-->
      <div class="tcDetails ct-centre">
        <div class="tcDetails-title">
          <img src="../../static/images/title-l.png" alt />
          <h3>老师简介</h3>
          <img src="../../static/images/title-r.png" alt />
        </div>
        <div class="tcDetails-ct">
          <div class="tcDetails-ct-top">
            <div class="classVideo">
              <iframe
                v-if="detailsData.video"
                :src="detailsData.video"
                scrolling="no"
                border="0"
                frameborder="no"
                framespacing="0"
                allowfullscreen="true"
                style="width:560px;height:360px;"
              ></iframe>
              <div v-else>
                <img
                  :src="imgsrc+detailsData.name+'.jpg'"
                  alt
                  style="width:560px;height:319px;border-radius:5px"
                />
              </div>
            </div>
            <div class="teacherInfo">
              <div class="teacherInfo-top">
                <div class="teacherInfo-name">
                  <div class="name-top">
                    <h3>{{detailsData.name}}</h3>
                    <i>{{teacher_grade}}{{detailsData.sf}}老师</i>
                    <span>
                      <img src="../../static/images/sys.png" alt /> 马上联系老师
                    </span>
                  </div>
                  <div class="name-bt">{{detailsData.tags}}</div>
                </div>
                <div class="score">
                  <h5>好评率</h5>
                  <span>{{detailsData.percent}}</span>
                </div>
              </div>
              <div class="teacherInfo-ct-bt">
                <p v-html="detailsData.info"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tcDetails-list ct-centre">
        <div class="tcDetails-list-ct" v-if="detailsData.mj">
          <div class="tcDetails-list-title">
            <div class="shu"></div>
            <h5>独家秘籍</h5>
          </div>
          <div class="tcDetails-list-text"><span>{{detailsData.mj}}</span></div>
        </div>
        <div class="tcDetails-list-ct" v-if="detailsData.cj">
          <div class="tcDetails-list-title">
            <div class="shu"></div>
            <h5>教学成就</h5>
          </div>
          <div class="tcDetails-list-text"><span>{{detailsData.cj}}</span></div>
        </div>
        <div class="tcDetails-list-ct" v-if="detailsData.ry">
          <div class="tcDetails-list-title">
            <div class="shu"></div>
            <h5>获得荣誉</h5>
          </div>
          <div class="tcDetails-list-text"><span>{{detailsData.ry}}</span></div>
        </div>
        <div class="tcDetails-list-ct" v-if="detailsData.ts">
          <div class="tcDetails-list-title">
            <div class="shu"></div>
            <h5>个人特色</h5>
          </div>
          <div class="tcDetails-list-text">
            <span>{{detailsData.ts}}</span>
          </div>
        </div>
      </div>
      <div class="tcDetails-bt ct-centre">
        <div class="tcDetails-title">
          <img src="../../static/images/title-l.png" alt />
          <h3>闭环式课程 全方位服务</h3>
          <img src="../../static/images/title-r.png" alt />
        </div>
        <img src="../../static/images/details-bottom.png" alt />
      </div>
    </div>
    <floatewm class="floatewm"></floatewm>
  </div>
</template>

<script>
import shaixuan from "../components/shaixuan";
import floatewm from "../components/floatewm";

export default {
  name: "ckplayerPlugin",
  components: {
    shaixuan: shaixuan,
    floatewm: floatewm
  },
  computed: {
    teacher_grade() {
      if (this.detailsData.grade) {
        if (this.detailsData.grade.indexOf("高") != -1) {
          return "高中";
        } else if (this.detailsData.grade.indexOf("初") != -1) {
          return "初中";
        } else if (this.detailsData.grade.indexOf("年级") != -1) {
          return "小学";
        }
      }
    }
  },
  data() {
    return {
      imgsrc: "./static/images/tc/",

      detailsData: {},
      /*classifycurrent: 0,
      gradecurrent: 0,
      subjectcurrent: 0,
      formcurrent: 0,
      classify: [
        { text: "全部" },
        { text: "小学" },
        { text: "初中" },
        { text: "高中" }
      ],
      grade: [
        { text: "全部" },
        { text: "一年级" },
        { text: "二年级" },
        { text: "三年级" },
        { text: "四年级" },
        { text: "五年级" },
        { text: "六年级" },
        { text: "初一" },
        { text: "初二" },
        { text: "初三" },
        { text: "高一" },
        { text: "高二" },
        { text: "高三" }
      ],
      subject: [
        { text: "全部" },
        { text: "语文" },
        { text: "数学" },
        { text: "英语" },
        { text: "物理" },
        { text: "化学" },
        { text: "生物" },
        { text: "政治" },
        { text: "历史" },
        { text: "地理" }
      ],
      dates:[
        {text:"全部"},
        {text:"春季课"},
        {text:"秋季课"},

      ],
      form: [{ text: "试听课程" }, { text: "老师简介" }]*/
    };
  },
  mounted() {
    if (localStorage.getItem("linkdetils") != "") {
      this.detailsData = JSON.parse(localStorage.getItem("linkdetils"));
    } else {
      this.detailsData = this.$route.query.data;
    }
    // this.detailsData.info = this.detailsData.info.replace(/|/g, "");
  /*  console.log(this.detailsData);*/

    var _teacher_img =
      "../../static/images/tc/" + this.detailsData.name + ".jpg";
    var videoObject = {
      container: "#txvideo",
      variable: "player",
      autoplay: false,
      poster: _teacher_img,
      video: [[this.detailsData.video, "video/mp4", "中文标清", 0]]
    };
    var player = new ckplayer(videoObject);
    player.changeControlBarShow(false);
  },
  methods: {
   /* classifyclickact: function(index) {
      this.classifycurrent = index;
    },
    gradeclickact: function(index) {
      this.gradecurrent = index;
    },
    subjectclickact: function(index) {
      this.subjectcurrent = index;
    },
    formclickact: function(index) {
      this.formcurrent = index;
    },*/
    linkytowin() {
      window.location.href = "http://www.ytowin.com/";
    },
    linkindex() {
      localStorage.setItem(
        "condition",
        JSON.stringify({
          classifycurrent: 0,
          gradecurrent: 0,
          subjectcurrent: 0,
          datescurrent: 0,
          formcurrent: 0,
          data: {
            classify:"高中",
            grade: "全部",
            subject: "全部",
            dates:"全部"
          },
          link: "/introducelist"
        })
      );
      this.$router.push({
        path: "/"
      });
    },
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  .ct {
    width: 100%;
    margin: 20px auto;
  }
  .breadnav{
    margin: 20px auto;
    li{
      display: inline-block;
      color: #5bab52;
      cursor: pointer;
      &:last-child{
        color: #5bab52;
      }
      img{
        width: 78px;
        height: 33px;
        vertical-align: middle;
      }
    }
    .icon{
      color: #5bab52;
    }
  }
  .top-bg {
    .return {
      width: 1200px;
      margin: 0 auto;
      position: absolute;
      position: relative;
     span {
        cursor: pointer;
        left: 97%;
        top: -15px;
        padding: 95px 7px 5px 7px;
        color: #fff;
        text-align: center;
        width: 30px;
        height: 160px;
        position: absolute;
        background: url("../../static/images/return.png") no-repeat;
        background-size: 100%;
        -webkit-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        -ms-transition: all 0.5s ease;
        -o-transition: all 0.5s ease;
        transition: all 0.5s ease;
      }
      span:hover {
        top: 0px;
      }
    }
    img {
      width: 100%;
      min-width: 1200px;
    }
  }
  .tcDetails {
    /*margin-top: 100px;*/
    min-width: 1200px;
    margin: 100px auto 0;
    .tcDetails-title {
      display: flex;
      justify-content: center;
      margin-bottom: 73px;
      > h3 {
        font-size: 50px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 0px;
        color: #333333;
      }
    }
    .tcDetails-ct {
      .tcDetails-ct-top {
        display: flex;
        justify-content: space-between;
        .classVideo {
          position: relative;
          width: 621px;
          height: 349px;

          .classVideo-bt {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -29px;
            margin-top: -29px;
            width: 58px;
            height: 58px;
            background: #333333;
          }
        }
        .teacherInfo {
          width: 621px;
          height: 349px;
          .teacherInfo-top {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px dashed #dddddd;
            box-sizing: border-box;
            padding-bottom: 27px;
            margin-bottom: 29px;
            .teacherInfo-name {
              .name-top {
                > h3 {
                  display: inline-block;
                  font-size: 28px;
                  font-weight: normal;
                  line-height: 30px;
                  color: #333333;
                }
                > i {
                  display: inline-block;
                  margin-left: 20px;
                  font-style: normal;
                  font-size: 18px;
                  font-weight: normal;
                  color: #666666;
                }
                > span {
                  position: relative;
                  cursor: pointer;
                  margin-left: 29px;
                  display: inline-block;
                  width: 140px;
                  font-size: 14px;
                  height: 32px;
                  text-align: center;
                  line-height: 32px;
                  border-radius: 16px;
                  border: solid 1px #5bab52;
                  color: #5bab52;
                }
                > span:hover::before {
                  position: absolute;
                  top: 100%;
                  left: 50%;
                  margin-left: -58.5px;
                  content: "";
                  display: block;
                  width: 117px;
                  height: 115px;
                  background: url("../../static/images/ewm.png") no-repeat;
                  /*box-sizing: 100% 100%;*/
                }
              }
              .name-bt {
                margin-top: 37px;
                font-size: 18px;
                font-weight: normal;
                color: #333333;
              }
            }
            .score {
              width: 100px;
              height: 94px;
              background-color: #ffba00;
              border-radius: 4px;
              text-align: center;
              > h5 {
                line-height: 47px;
                font-size: 14px;
                font-weight: normal;
                color: #ffffff;
              }
              > span {
                line-height: 18px;
                font-size: 28px;
                color: #ffffff;
              }
            }
          }
          .teacherInfo-ct-bt {
            > p {
              font-size: 22px;
              line-height: 34px;
              font-weight: normal;
              color: #333333;
            }
          }
        }
      }
    }
  }
  .tcDetails-list {
    margin-top: 100px;
    .tcDetails-list-ct {
      float: left;
      width: 560px;
      margin-top: 30px;
      margin-right: 80px;
      margin-bottom: 15px;
      .tcDetails-list-title {
        display: flex;
        align-items: center;
        .shu {
          width: 8px;
          height: 24px;
          background-color: #5bab52;
          border-radius: 4px;
        }
        > h5 {
          margin-left: 16px;
          font-size: 24px;
          font-weight: normal;
          color: #333333;
        }
      }

      .tcDetails-list-text {
        margin-top: 36px;
        box-sizing: border-box;
        border: 1px dashed #dddddd;
        height: 132px;
        padding: 23px 25px;
        span {
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          opacity: 0.8;
        }
      }
    }
    .tcDetails-list-ct:nth-child(2n + 2) {
      margin-right: 0;
    }
  }
  .tcDetails-list::after {
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .tcDetails-bt {
    .tcDetails-title {
      margin-top: 58px;
      display: flex;
      justify-content: center;
      margin-bottom: 73px;
      > h3 {
        font-size: 50px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 30px;
        letter-spacing: 0px;
        color: #333333;
      }
    }

    margin-top: 189px;
    > img {
      width: 1200px;
    }
  }
  .floatewm {
    z-index: 99;
    position: fixed;
    right: 17px;
    top: 48%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/details.vue